import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=a54b1e44&scoped=true&"
import script from "./CompaniesList.vue?vue&type=script&lang=js&"
export * from "./CompaniesList.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesList.vue?vue&type=style&index=0&id=a54b1e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54b1e44",
  null
  
)

export default component.exports